export default __webpack_public_path__ + "static/media/hyundai.e33a3381.jpg";